import {
  fetchMeetingReport,
  fetchSearch,
  fetchSimpleReport,
  fetchTicketsData,
} from 'api/report/realTime'
import { RTDReportTypes } from 'api/report/realTime/types'
import useReportSWR from 'hooks/useReportSWR'
import { RTD_SWR_CONFIG } from 'layouts/RealTimeDashboard/constants'

const missedChatsQuery = { metric: RTDReportTypes.MISSED_CHATS_AGENT }
export const useMissedChatsQuery = () =>
  useReportSWR(
    missedChatsQuery.metric,
    missedChatsQuery,
    () => fetchSimpleReport(missedChatsQuery),
    RTD_SWR_CONFIG
  )

const convosQuery = { metric: RTDReportTypes.OPEN_CLOSED_CONVOS }
export const useOpenAndClosedConvosQuery = () =>
  useReportSWR(
    convosQuery.metric,
    convosQuery,
    () => fetchSimpleReport(convosQuery),
    RTD_SWR_CONFIG
  )

const leadsByAgentQuery = { metric: RTDReportTypes.LEADS }
export const useLeadsQualifiedByAgentQuery = () =>
  useReportSWR(
    leadsByAgentQuery.metric,
    leadsByAgentQuery,
    () => fetchSimpleReport(leadsByAgentQuery),
    RTD_SWR_CONFIG
  )

const leadsQuery = { metric: RTDReportTypes.LEADS_SEARCH }
export const useLeadsQualifiedQuery = () =>
  useReportSWR(
    leadsQuery.metric,
    leadsQuery,
    () => fetchSearch(leadsQuery),
    RTD_SWR_CONFIG
  )

const totalConvosQuery = { metric: RTDReportTypes.TOTAL_CONVOS }
export const useTotalConvosQuery = (botId) =>
  useReportSWR(
    totalConvosQuery.metric,
    { ...totalConvosQuery, botId },
    botId ? () => fetchSimpleReport({ ...totalConvosQuery, botId }) : () => [],
    RTD_SWR_CONFIG
  )

const meetingsQuery = { metric: RTDReportTypes.MEETINGS_BOOKED }
export const useMeetingsBookedQuery = () =>
  useReportSWR(
    meetingsQuery.metric,
    meetingsQuery,
    () => fetchMeetingReport(meetingsQuery),
    RTD_SWR_CONFIG
  )

const performanceQuery = { metric: RTDReportTypes.REP_PERFORMANCE }
export const useRepPerformanceQuery = () =>
  useReportSWR(
    performanceQuery.metric,
    performanceQuery,
    () => fetchSimpleReport(performanceQuery),
    RTD_SWR_CONFIG
  )

const liveChatRatingQuery = { metric: RTDReportTypes.CHAT_RATINGS }
export const useLiveChatRatingQuery = () =>
  useReportSWR(
    liveChatRatingQuery.metric,
    liveChatRatingQuery,
    () => fetchSimpleReport(liveChatRatingQuery),
    RTD_SWR_CONFIG
  )

const ticketsCreatedQuery = { metric: 'ticketsCreated-conversations' }
export const useTicketsCreatedQuery = (orgId) =>
  useReportSWR(
    ticketsCreatedQuery.metric,
    { org: orgId },
    () => fetchTicketsData(orgId),
    RTD_SWR_CONFIG
  )

const notRespondedQuery = { metric: RTDReportTypes.NOT_RESPONDED }
export const useNotRespondedQuery = () =>
  useReportSWR(
    notRespondedQuery.metric,
    notRespondedQuery,
    () => fetchSimpleReport(notRespondedQuery),
    RTD_SWR_CONFIG
  )
